module.exports = __webpack_public_path__ + "static/media/laborArticle1.0364037b.jpg";